import { Controller } from 'react-hook-form';
import { prop } from 'ramda';
import {
  Card,
  Icon,
  InfoMessage,
  InfoTooltip,
  Message,
  Switch
} from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';

const ControlledSwitch = ({
  hideLabel = false,
  rules = {},
  name,
  form,
  label,
  containerClassName = '',
  labelClassNames = '',
  labelPosition = 'left',
  disabled = false,
  displayError = true,
  recommended = false,
  infoMessage = '',
  extraClick = () => {},
  isDisplayed = true,
  tooltip = '',
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }

  const labelClasses = `${labelClassNames} ${hideLabel ? ' hidden' : ' cursor-pointer'} ${disabled ? 'text-gray-300' : 'text-black'}`;
  const _containerClassName = `flex w-full gap-x-4 items-center mb-4 ${labelPosition === 'right' ? 'flex-row-reverse gap-x-4 justify-end' : ''}`;

  const content = (
    <div
      className={_containerClassName}
      onClick={() => {
        extraClick();
        form.trigger();
      }}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => (
          <>
            <div>
              <Switch
                {...props}
                {...props.field}
                {...extraProps}
                disabled={disabled}
                checked={props.field.value}
              />
            </div>

            <div className="flex items-center gap-2">
              <label
                className={labelClasses}
                onClick={() => {
                  if (!disabled) {
                    props.field.onChange(!props.field.value);
                  }
                }}>
                {label} {prop('required', rules) && '*'}
              </label>
              {tooltip && <InfoTooltip text={tooltip} />}
            </div>
          </>
        )}
      />
      {displayError && (
        <Message variant="error" label={getErrorMessage(form.formState.errors, name)} />
      )}
    </div>
  );

  return recommended ? (
    <Card className={containerClassName} variant="secondary" header="Recommandée">
      {content}
      <InfoMessage className="mt-4 mb-8" iconName="lightbulb">
        {infoMessage}
      </InfoMessage>
      {tooltip && (
        <div className="flex md:hidden w-full relative top-[5px] bg-[#F2F7FE] rounded-md px-4 py-4 mt-2">
          <div className="flex items-center">
            <Icon name="info_question" size={40} />
            <span className="text-black text-base font-normal ml-2">{tooltip}</span>
          </div>
        </div>
      )}
    </Card>
  ) : (
    <div className={containerClassName}>
      {content}
      <InfoMessage className="mt-4 mb-8" iconName="lightbulb">
        {infoMessage}
      </InfoMessage>
      {tooltip && (
        <div className="flex md:hidden w-full relative top-[5px] bg-[#F2F7FE] rounded-md px-4 py-4 mt-2">
          <div className="flex items-center">
            <Icon name="info_question" size={40} />
            <span className="text-black text-base font-normal ml-2">{tooltip}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ControlledSwitch;
